import { useLanguage } from "@/i18n/LanguageContext";

// One slow editorial marquee — low contrast, decorative only
export default function Marquee() {
  const { t } = useLanguage();
  const line = t("marquee");
  return (
    <div className="relative overflow-hidden border-y border-red-900/25 bg-[#0D0608] py-4" aria-hidden="true" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((i) => (
          <span key={i} className="font-display text-sm font-bold uppercase tracking-[0.3em] text-zinc-600">
            {line.repeat(4)}
          </span>
        ))}
      </div>
    </div>
  );
}
